export const MOCK_TARIFF_ID = '22dddca7-a4dc-4f49-add9-bd5fb3494d9a'
export const MOCK_WALLBOX_NAME = 'EdisonConnect'
export const MOCK_WALLBOX_NAME_2 = 'EasyConnect'
export const MOCK_WALLBOX_ID = '65ec821d-09f4-4619-b2c4-43b5045cc981'
export const MOCK_CURRENCY = 'EUR'
export const MOCK_ENERGY_TYPE = 'ENERGY'
export const MOCK_INSTALLATION_ID = 10000
export const MOCK_VAT_RATE = 19
